import React from "react";
import { Link } from "react-router-dom";

/**
 * Pond-detail workflow navigation (matches UpdatePD and related pages).
 * @param {{ id: string|number, active: 'general'|'pondFish'|'sampling'|'gallery'|'table'|'graph'|'notes' }} props
 */
export default function PondDetailWorkflowTabs({ id, active }) {
  const sid = id != null && id !== "" ? String(id) : "";
  if (!sid) return null;

  const tabClass = (key) =>
    `nav-link px-3 py-2 rounded-top${active === key ? " donezo-tab-active" : ""}`;

  return (
    <div className="card border-0 shadow-sm mb-4 donezo-workflow-tabs">
      <ul className="nav nav-tabs border-0">
        <li className="nav-item me-2">
          <Link to={`/UpdatePD/${sid}`} className={tabClass("general")}>
            <i className="fas fa-cog me-2" aria-hidden />
            General
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/pondFishViaPondDetail/${sid}`} className={tabClass("pondFish")}>
            <i className="fas fa-fish me-2" aria-hidden />
            Fish Sampled/Caught
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/samplingViaPondDetail/${sid}`} className={tabClass("sampling")}>
            <i className="fas fa-chart-line me-2" aria-hidden />
            Sampling Detail
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/samplingGalleryViaPondDetail/${sid}`} className={tabClass("gallery")}>
            <i className="fas fa-images me-2" aria-hidden />
            Gallery
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/FishDataTableView/${sid}`} className={tabClass("table")}>
            <i className="fas fa-table me-2" aria-hidden />
            Table view
          </Link>
        </li>
        <li className="nav-item me-2">
          <Link to={`/fish-data-graph-new/${sid}`} className={tabClass("graph")}>
            <i className="fas fa-chart-area me-2" aria-hidden />
            Graph view
          </Link>
        </li>
        <li className="nav-item">
          <Link to={`/pondNoteViaPondDetail/${sid}`} className={tabClass("notes")}>
            <i className="fas fa-note-sticky me-2" aria-hidden />
            Notes
          </Link>
        </li>
      </ul>
    </div>
  );
}
